module.exports = __webpack_public_path__ + "assets/07e798e818192f8efe2fcd2583b0894f.mp4";